const CrudIndexDS = {
    meta: {links: [] ,last_page: 1},
    headerTitle: '',
    currentPage: 1,
    dataPerPage: 10,
    list: [],
    keyword: ''
}

export default CrudIndexDS